import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';

@Component({
  selector: 'app-text-with-image',
  templateUrl: './text-with-image.component.html',
  styleUrls: ['./text-with-image.component.css'],
})
export class TextWithImageComponent implements OnInit {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  @Input() service!: any;

  @ViewChild('carouselTrack') carouselTrack!: ElementRef<HTMLElement>;

  activeIndex = 0;
  isMobile = false;

  private touchStartX = 0;

  ngOnInit(): void {
    this.checkMobile();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }

  checkMobile(): void {
    this.isMobile = window.innerWidth <= 575;
  }

  get filteredServices(): any[] {
    const services = this.data?.services ?? [];
    if (!this.service) return services;
    return services.filter((item: any) => item.title !== this.service.title);
  }

  goToSlide(index: number): void {
    this.activeIndex = index;
    const track = this.carouselTrack?.nativeElement;
    if (!track) return;

    const slide = track.querySelector('.carousel-slide') as HTMLElement;
    if (!slide) return;

    const slideWidth = slide.offsetWidth + 12;
    track.style.transition = 'transform 0.35s ease';
    track.style.transform = `translateX(${index * slideWidth}px)`;
  }

  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.touches[0].clientX;
  }

  onTouchMove(event: TouchEvent): void {
    const diff = this.touchStartX - event.touches[0].clientX;
    const track = this.carouselTrack?.nativeElement;
    if (!track) return;

    const slide = track.querySelector('.carousel-slide') as HTMLElement;
    if (!slide) return;

    const slideWidth = slide.offsetWidth + 12;
    const base = this.activeIndex * slideWidth;

    track.style.transition = 'none';
    track.style.transform = `translateX(${base - diff}px)`;
  }

  onTouchEnd(event: TouchEvent): void {
    const track = this.carouselTrack?.nativeElement;
    if (track) track.style.transition = 'transform 0.35s ease';

    const diff = this.touchStartX - event.changedTouches[0].clientX;
    const total = this.filteredServices.length;

    if (Math.abs(diff) > 40) {
      if (diff < 0 && this.activeIndex < total - 1) {
        this.goToSlide(this.activeIndex + 1);
      } else if (diff > 0 && this.activeIndex > 0) {
        this.goToSlide(this.activeIndex - 1);
      } else {
        this.goToSlide(this.activeIndex);
      }
    } else {
      this.goToSlide(this.activeIndex);
    }
  }

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${object.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
